var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.token == null)?_c('span',{staticStyle:{"word-break":"break-word"}},[_vm._v(_vm._s(_vm.userfullname))]):_c('router-link',{staticStyle:{"word-break":"break-word"},attrs:{"to":{
          name: _vm.route,
          params: {
            username: _vm.row[_vm.column.name],
          },
          query: {
            token: _vm.token
          }
        }},on:{"click":function($event){return _vm.clickHandler()}}},[_vm._v(_vm._s(_vm.userfullname)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }